// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MDButton } from './MDButton';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TerceraButtonEvents, TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
export class BuySellMDButton extends MDButton {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('side', this.onSideChanged);
    }
    onSideChanged(side) {
        const buy = side === OperationType.Buy;
        void this.set({
            terceraButtonStyle: buy ? TerceraButtonStyle.Blue : TerceraButtonStyle.Red,
            locKey: buy ? 'panel.Level2.oe.BuyButton' : 'panel.Level2.oe.SellButton'
        });
    }
    private_MouseClick(e) {
        if (e === null || e === void 0 ? void 0 : e.original) {
            this.lastMouseClickX = e.original.clientX;
            this.lastMouseClickY = e.original.clientY;
        }
        if (!this.get('enabled')) {
            return;
        }
        const side = this.get('side');
        this.fire(TerceraButtonEvents.onClick, side);
    }
}
MDButton.extendWith(BuySellMDButton, {
    data: function () {
        return {
            side: null
        };
    }
});
